import { ErrorMessage, Field, useField } from "formik";
import * as React from "react";
import TextError from "./TextError";
import {
    checkValidationElement,
    setchioldValidation,
    valudatesetformstatus,
} from "../../pages/onboarding/Onboarding";
import Multiselect from "multiselect-react-dropdown";

const MultiSelect = (props: any) => {
    const { name, allData, formik, ...rest } = props;

    const fieldValidation = (values: any[]) => {
        if (allData.is_child_validate && values?.length > 0) {
            const checkData = checkValidationElement.map((ress: any) => {
                const selectedVals = values?.map((e) => e?.value);
                return {
                    ...ress,
                    childValidation:
                        allData.name === ress.parent_name && selectedVals.some(e => ress.parent_value?.includes(e))
                };
            });
            setchioldValidation(checkData);
        }

        let error;
        if (allData.validate) {
            if (allData.type === "multiSelect") {
                allData?.validations.forEach((element: any) => {

                    if (element.type === "required") {
                        if ((!values || values.length === 0) && valudatesetformstatus !== "draft") {
                            error = element.params[0];
                        }
                    }
                });
            }
        }
        return error;
    };

    const [field, , helpers] = useField({
    name,
        validate: (values: any[]) =>  fieldValidation(values),
    });

    

    return (
        <>
            <div className="class-name position-relative">
                <Multiselect
                    options={allData?.values || []} // expects array of {label, value}
                    selectedValues={field.value || []} // Formik field value
                    onSelect={(selectedList) => helpers.setValue(selectedList)}
                    onRemove={(selectedList) => helpers.setValue(selectedList)}
                    displayValue="label"
                    placeholder={allData.placeholder || "Select options"}
                    classNamePrefix="custom-multi"
                    {...rest}
                />

                <ErrorMessage name={name} component={TextError} />
            </div>
        </>
    );
};

export default MultiSelect;
